const COMMON_CONFIGS = {
  recaptcha_key: process.env.REACT_APP_RECAPTCHA_SECRET_KEY,
  website_url: process.env.REACT_APP_PATIENT_URL
};

const config = {
  production: {
    ...COMMON_CONFIGS,
    env: process.env.NODE_ENV,
    base_url: process.env.REACT_APP_GATEWAY_URL
  },
  development: {
    ...COMMON_CONFIGS,
    env: process.env.NODE_ENV,
    // LOCAL
    base_url: 'http://localhost:3001',
    // graphql_url: 'http://192.168.88.46:5010'
    // PROD
    // base_url: 'https://api-admin.medicusunion.com',
    // graphql_url: 'https://gql.medicusunion.com'
    // STAGING
    // base_url: 'https://stg-gateway.medicusunion.me',
    website_url: 'https://stg.medicusunion.me'
  },
  test: {
    ...COMMON_CONFIGS,
    env: process.env.NODE_ENV,
    base_url: process.env.REACT_APP_GATEWAY_URL
  }
};

export default config[process.env.NODE_ENV];
